import React from 'react';

export function NewDocumentPage() {
  return <div>New Document Page</div>;
}
